import React, { useState, useMemo } from 'react';
import style from './index.module.scss';
import Icon from '@/components/Icon';
import { Popup } from 'antd-mobile';
import PopupHeader from '@/components/PopupHeader';
import TypeItem from '../../TypeItem';
import Price from '../../Price';
import IPList from '../../IPList';
import FactoryList from '../../FactoryList';
import type { InitQueryType } from '../../index';
import type { MallParams } from '@/stores';
import { useMallParams } from '@/stores';
import cls from 'classnames';

interface Props {
  isNormalProduct?: boolean;
  initValues: InitQueryType;
  changeFator: (fator: MallParams) => void;
}

const MobileFilter: React.FC<Props> = ({
  isNormalProduct,
  initValues,
  changeFator,
}) => {
  const { mallParams } = useMallParams();
  const [visible, setVisible] = useState(false);
  const filterCount = useMemo(() => {
    let count = 0;
    if (mallParams) {
      try {
        if (mallParams['ip_id__in']) {
          count += mallParams['ip_id__in'].split(',').length;
        }
        if (mallParams['factory__in']) {
          count += mallParams['factory__in'].split(',').length;
        }
        if (mallParams['price__range']) {
          count += 1;
        }
        if (mallParams['type']) {
          count += 1;
        }
      } catch (error) {}
    }
    return count;
  }, [mallParams]);
  return (
    <div>
      <span
        className={cls(style.filter, filterCount > 0 ? style.activeFilter : '')}
        onClick={() => {
          setVisible(true);
        }}
      >
        <Icon id="#hxicon-filter" className={style.icon} />
        Filter{filterCount > 0 ? `(${filterCount})` : ''}
      </span>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        position="left"
        bodyStyle={{
          width: '80vw',
          background: '#ffffff',
          overflowY: 'scroll',
        }}
      >
        <div>
          <PopupHeader
            title="Filter"
            color="#333333"
            onClick={() => {
              setVisible(false);
            }}
          />
          <div className={style.main}>
            {isNormalProduct && (
              <TypeItem initValue={initValues.type} changeFator={changeFator} />
            )}
            <Price initValue={initValues.price} changeFator={changeFator} />
            <IPList initValue={initValues.ips} changeFator={changeFator} />
            <FactoryList
              initValue={initValues.factory}
              changeFator={changeFator}
            />
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default MobileFilter;
